import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from '@shared/alert/alert.service';
import { Subscription } from 'rxjs';
import { AlertMessage } from './alert.interfaces';

/**
 * Componente para exibição de alertas/mensagens
 *
 * Características:
 * - Exibe mensagens do AlertService
 * - Aplica classes CSS apropriadas automaticamente
 * - Auto-gerencia sua própria limpeza (unsubscribe)
 *
 * Uso no template:
 * <alert></alert>
 *
 * Classes CSS por tipo:
 * - success: alert-success
 * - error: alert-danger
 * - info: alert-info
 * - warning: alert-warning
 *
 * Observação: Deve ser incluído apenas uma vez, tipicamente no app.component
 */

@Component({ selector: 'alert', templateUrl: 'alert.component.html' })
export class AlertComponent implements OnInit, OnDestroy {
    private subscription: Subscription;
    message: AlertMessage | null;

    constructor(private alertService: AlertService) {}

    ngOnInit() {
        this.subscription = this.alertService.getAlert().subscribe(message => {
            if (!message) {
                this.message = null;
                return;
            }

            const cssClass = this.getAlertClass(message.type);

            this.message = {
                ...message,
                cssClass: `alert ${cssClass}`,
            };
        });
    }

    private getAlertClass(type: AlertMessage['type']): string {
        const classMap = {
            success: 'alert-success',
            error: 'alert-danger',
            info: 'alert-info',
            warning: 'alert-warning',
        };
        return classMap[type];
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
}
